import React from 'react'
import './sidebar.css'
import { connect } from 'react-redux'
import { other } from './sectionTypes'
import { Link } from 'react-router-dom'

const Sidebar = props => {
    let { contributor, groups, confidentialGroups, is_user_editor } = props
    const sct = props.sections || [];
    let sections = sct ? sct.concat() : [];

    if (sections) {
        other.forEach(s => {
            sections.push(s)
        })
        sections = sections.map(k => {
            k.label = k.label.split('/')[0].trim();
            return k;
        })
    }
    return contributor ? (
        <div className="sidebar w-300 col-auto d-none d-md-block print-none shadow">
            {contributor.ISO2 && (
                <div className="text-center">
                    <img className="flag-main mt-4 mb-3" src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/v1/${contributor.ISO2.toLowerCase()}.png`} alt={contributor.ISO3} />
                </div>
            )}
            <ul className="nav nav-pills flex-column w-300 mt-2">
                <li className="divider mb-2">Table of Contents</li>
                <li className="nav-item ">
                    <a className="nav-link" href="#top"><i className="fas fa-angle-up"></i> Back to top</a>
                </li>
                {sections && sections.filter(k => !k.confidential || (k.confidential && groups.some(b => confidentialGroups.indexOf(b) > -1))).map((section, idx) => (
                    <li key={idx} className="nav-item">
                        <a className="nav-link" href={`#section-${section.id}`}><i className={`fas fa-${section.confidential ? 'lock' : (section.icon || 'hashtag')}`}></i> {section.label}</a>
                        {section.children && section.children.length ? (
                            <ul>
                                {section.children.map((child, idx2) => (
                                    <li key={idx2}>
                                        <a style={{ color: '#FFF', textDecoration: 'none' }} href={`#section-${child.id}`}>{child.label}</a>
                                    </li>
                                ))}
                            </ul>
                        ) : null}
                    </li>
                ))}
                {is_user_editor ? (
                    <li className="print-none nav-item"><Link className="nav-link" to={`/contributor/${contributor.ContributorID}/audit`}><i className="fas fa-lock" /> Audit Trail</Link></li>
                ) : null}
            </ul>
        </div>
    ) : null
}

const mapStateToProps = ({ okta, general }) => {
    return {
        sections: general.sections,
        files: general.sharepoint_files,
        contributor: general.contributor,
        groups: okta.groups,
        confidentialGroups: okta.confidentialGroups,
        is_user_editor: okta.is_user_editor
    }
}

export default connect(mapStateToProps)(Sidebar)